import { enumToNumberMap } from '../helpers/enums';

export interface PlanWizardState {
  planData: PlanData;
  organizationId?: number;
}

export const InitialPlanWizardState: PlanWizardState = {
  planData: {},
};

export interface PlanData {
  id?: string;
  planName?: string;
  planType?: string;
  rkPlanId?: string;
  planSponsorName?: string;
  planAnniversaryDate?: string;
  employerContributions?: EmployerContributionsData[];
  employerContributionName?: string;
  deferralChoiceAllowed?: string;
  roth401kAllowed?: boolean;
  planContribPercentLimitPosttax?: number;
  levelOfService?: string;
}

export interface EmployerContributionsData {
  category?: number;
  dimension?: string;
  employerContributionDollarMax?: number;
  contributionTiers?: ContributionTierData[];
  matchingCode?: string;
}

export interface ContributionTierData {
  from?: number;
  to?: number;
  percentContribution?: number;
}

export enum EmployerContributionCategoryEnum {
  'Pre-Tax' = 1,
  'After-Tax' = 2,
  'Profit Sharing' = 3,
  'Plan' = 4,
  'Roth' = 5,
}

export const EmployerContributionCategoryEnumMap = enumToNumberMap(
  Object.entries(EmployerContributionCategoryEnum),
  '#',
);

export function getDistinctMatchingCodes(
  employerContributions?: EmployerContributionsData[],
): string[] {
  const codes = new Set<string>();
  employerContributions?.forEach(contribution => {
    if (contribution.matchingCode !== undefined && contribution.matchingCode !== null) {
      codes.add(contribution.matchingCode);
    }
  });
  return Array.from(codes);
}

export function hasMatchingCodes(employerContributions?: EmployerContributionsData[]): boolean {
  return getDistinctMatchingCodes(employerContributions).length > 0;
}
